import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { fetchProducts } from "../../lib/api";
import { ProductCard } from "../ProductCard";

export const NewArrivals = () => {
  const [products, setProducts] = useState([]);
  const scroller = useRef(null);

  useEffect(() => {
    fetchProducts({ sort: "newest", limit: 10 }).then(setProducts).catch(() => {});
  }, []);

  const scrollBy = (dir) => {
    scroller.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  return (
    <section className="pt-6 sm:pt-8 pb-12 sm:pb-16" data-testid="new-arrivals-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-end justify-between gap-6">
          <div>
            <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">Fresh off the loom</p>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3">New from Ilkal</h2>
          </div>
          <div className="hidden sm:flex gap-2">
            <button onClick={() => scrollBy(-1)} data-testid="newarrivals-prev-btn" aria-label="Previous" className="w-11 h-11 border border-gold/40 flex items-center justify-center text-charcoal hover:bg-gold/10 transition-colors">
              <ChevronLeft className="w-5 h-5" strokeWidth={1.5} />
            </button>
            <button onClick={() => scrollBy(1)} data-testid="newarrivals-next-btn" aria-label="Next" className="w-11 h-11 border border-gold/40 flex items-center justify-center text-charcoal hover:bg-gold/10 transition-colors">
              <ChevronRight className="w-5 h-5" strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div ref={scroller} className="mt-7 flex gap-4 sm:gap-6 overflow-x-auto no-scrollbar snap-x -mx-4 px-4 lg:mx-0 lg:px-0">
          {products.map((p) => (
            <div key={p.id} className="min-w-[68vw] sm:min-w-[300px] lg:min-w-[calc(25%-1.5rem)] snap-start">
              <ProductCard product={p} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
